<template>
    <Modal id="credit-card-needed" :show-footer="false" :show-title="false" design="v3" @cancel="cancel">
        <div class="content">
            <div class="icon-wrapper">
                <CreditCardNeeded />
            </div>
            <div class="title">Kredi Kartı Zorunlu</div>
            <div class="description">Herhangi bir satın alım için kredi kartı zorunludur. Lütfen kredi kartınızı giriniz.</div>
            <SupsisButton primary @click="forward">Devam Et</SupsisButton>
        </div>
    </Modal>
</template>
<script>
import Modal from "../common/Modal2.vue";
import CreditCardNeeded from "../svg/CreditCardNeeded.vue";
import systemPubSub from "../../utils/systemPubSub";
import SupsisButton from "@/views/Pages/Settings/components/SupsisButton.vue";
export default {
    name: "CreditCardNeededModal",
    components: {
        Modal,
        CreditCardNeeded,
        SupsisButton
    },
    methods: {
        cancel() {
            this.$emit("close");
        },
        forward() {
            this.$router.push("/settings/billing?focus=creditCard");
            systemPubSub.publish("settings_page_changed", {
                name: "billing"
            });
            this.$emit("close");
        },
    },
    mounted() {},
    beforeDestroy() {},
};
</script>
<style scoped lang="scss">
#credit-card-needed {
    .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        padding: 32px 24px;
        gap: 16px;

        .icon-wrapper {
            background: #ffeded;
            width: 96px;
            height: 96px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .title {
            font-size: 26px;
            font-weight: bold;
            margin-top: 8px;
        }

        .description {
            font-size: 16px;
            max-width: 420px;
            line-height: 1.6;
        }

        ::v-deep .supsis-button.primary {
            min-width: 160px;
            height: 44px;
            font-size: 16px;
        }
    }
}
</style>
